import React, { type FC } from 'react';

import { LoadableAfterPaint, useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

export const ContextualCreateContentPopoverLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualCreatePopover" */ '../CreateContentPopover/index.ts'
			)
		).ContextualCreateContentPopover,
});

type TreeBottomCreateButtonProps = {
	spaceKey: string;
	source: string;
};

export const TreeBottomCreateButton: FC<TreeBottomCreateButtonProps> = ({ spaceKey, source }) => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();

	return (
		<div
			data-testid="page-tree-create-button"
			data-vc="page-tree-create-button"
			{...ssrPlaceholderIdProp}
		>
			<ContextualCreateContentPopoverLoader
				spaceKey={spaceKey}
				source={source}
				isTreeItem
				shouldRenderToParent
			/>
		</div>
	);
};
